import type { ReactNode } from 'react';

import { getLocale } from '../../i18n';
import { Absent } from './Absent';
import { count, share } from './format';
import { mt } from './messages';

export function Withheld(props: {
  suppressedShare: number;
  total: number | null;
  source: 'commenters' | 'electorate';
}): ReactNode {
  const locale = getLocale();
  return (
    <div className="text-caption text-muted-foreground flex flex-col gap-1">
      {props.suppressedShare > 0 && (
        <span data-numeric>
          {mt('withheld.share', { share: share(props.suppressedShare, locale) })}
        </span>
      )}
      {props.total === null ? (
        <Absent reason="withheld" />
      ) : (
        <span data-numeric>{mt('withheld.total', { total: count(props.total, locale) })}</span>
      )}
      {props.source === 'commenters' ? (
        <span>{mt('withheld.biased')}</span>
      ) : (
        <span>{mt('withheld.electorate')}</span>
      )}
    </div>
  );
}
